'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _require = require('leaflet-geosearch'),
    OpenStreetMapProvider = _require.OpenStreetMapProvider;

var CustomOSMProvider = function (_OpenStreetMapProvide) {
    _inherits(CustomOSMProvider, _OpenStreetMapProvide);

    function CustomOSMProvider() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _classCallCheck(this, CustomOSMProvider);

        var _this = _possibleConstructorReturn(this, (CustomOSMProvider.__proto__ || Object.getPrototypeOf(CustomOSMProvider)).call(this, options));

        var host = 'https://nominatim.openstreetmap.org';
        _this.searchUrl = options.searchUrl || host + '/search';
        _this.reverseUrl = options.reverseUrl || host + '/reverse';
        return _this;
    }

    _createClass(CustomOSMProvider, [{
        key: 'endpoint',
        value: function endpoint(_ref) {
            var query = _ref.query,
                type = _ref.type,
                country = _ref.country,
                postalcode = _ref.postalcode;

            var params = typeof query === 'string' ? { q: query } : query;
            params.format = 'jsonv2';
            params.country = country;
            params.postalcode = postalcode;

            switch (type) {
                // RequestType.REVERSE === 1
                case 1:
                    return this.getUrl(this.reverseUrl, params);

                default:
                    return this.getUrl(this.searchUrl, params);
            }
        }
    }, {
        key: 'parse',
        value: function parse(response) {
            var records = Array.isArray(response.data) ? response.data : [response.data];

            return records.map(function (r) {
                return {
                    x: Number(r.lon),
                    y: Number(r.lat),
                    label: r.display_name,
                    bounds: [[parseFloat(r.boundingbox[0]), parseFloat(r.boundingbox[2])], // s, w
                    [parseFloat(r.boundingbox[1]), parseFloat(r.boundingbox[3])]],
                    raw: r
                };
            });
        }
    }, {
        key: 'getParamString',
        value: function getParamString() {
            var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            var set = Object.assign({}, this.options.params, params);
            return Object.keys(set).filter(function (key) {
                return !!set[key];
            }).map(function (key) {
                return encodeURIComponent(key) + '=' + encodeURIComponent(set[key]);
            }).join('&');
        }
    }, {
        key: 'getUrl',
        value: function getUrl(url, params) {
            return url + '?' + this.getParamString(params);
        }
    }, {
        key: 'search',
        value: function search(options) {
            var _this2 = this;

            return new Promise(function (resolve) {
                var url = _this2.endpoint({
                    query: options.query,
                    // RequestType.SEARCH === 0
                    type: 0,
                    country: options.country,
                    postalcode: options.postalcode
                });

                return resolve(fetch(url));
            }).then(function (request) {
                return request.json();
            }).then(function (json) {
                return _this2.parse({ data: json });
            });;
        }
    }]);

    return CustomOSMProvider;
}(OpenStreetMapProvider);

module.exports = CustomOSMProvider;


//////////////////
// WEBPACK FOOTER
// ./assets/js/src/osm-provider/index.js
// module id = 12
// module chunks = 0